import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./TransportLogin.css"; // Unieke styling alleen voor transport login

const TransportLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/transport/login`,
        {
          username,
          password,
        }
      );

      const data = response.data;

      if (data) {
        // ✅ Zet transportmodus aan
        localStorage.setItem("transportMode", "1");

        // ✅ Sla transportUser op (met alleen relevante info)
        const transportUser = {
          username: data.username || username,
          company:
            data.company ||
            data.shippingAgent ||
            data.bedrijf ||
            "Onbekend", // kies juiste veld uit backend
          token: data.token || null,
        };

        localStorage.setItem("transportUser", JSON.stringify(transportUser));

        console.log(
          "🚛 Transportmodus geactiveerd voor:",
          transportUser.company
        );

        // ✅ Redirect per gebruiker:
        // - hal  -> /transport/warehouse
        // - anderen (hermus, wpk, thijs, ...) -> /transport/home
        if (transportUser.username === "hal") {
          navigate("/transport/warehouse");
        } else {
          navigate("/transport/home");
        }
      } else {
        setError("Geen geldige respons ontvangen van de server.");
      }
    } catch (err) {
      console.error("❌ Transport login mislukt:", err);
      setError("Inloggegevens onjuist. Probeer opnieuw.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="transport-login-wrapper">
      <h2>Transport Melder</h2>
      <form onSubmit={handleLogin} className="transport-login-form">
        <input
          type="text"
          placeholder="Gebruikersnaam"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Wachtwoord"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {error && <p className="transport-error-message">{error}</p>}
        <button type="submit" disabled={isLoading}>
          {isLoading ? "Inloggen..." : "Inloggen"}
        </button>
      </form>
    </div>
  );
};

export default TransportLogin;
